import React from 'react';
import { FormItem } from '../../item/FormItem';
import { DraggerInput, DraggerInputProps } from './DraggerInput';

export interface DraggerInputItemProps extends DraggerInputProps {
  label: string;
}

/**
 * Componente Dragger con FormItem di Antd
 *
 * @deprecated
 *
 * Sostituire cone elementi separati
 *
 * @param title Permette di sovrascrivere il messaggio principale.
 * @param info Permette di sovrascrivere il testo di aiuto per l'utente.
 */

export function DraggerInputItem(props: DraggerInputItemProps) {
  const { name, label, ...draggerProps } = props;
  return (
    <FormItem name={name} label={label}>
      <DraggerInput {...draggerProps} />
    </FormItem>
  );
}
